// extracted by mini-css-extract-plugin
module.exports = {"city":"_3TrMy1XIopam1OEWGtH2pR","red-border":"iPc0cUu6trcfIpNTQKa2Z","select-city-big":"_2zP6GteioHKdFPal3wQo-f","select-city-small":"_2jYUYPtdZ4_4LjKhgS02HM"};